/**
 * This is your Salesforce org id
 */
const orgId = '00DE0000000JouaMAC';
/**
 * The trigger node name in your BookIt For Forms Flowbuilder
 */
const nodeName = 'Request a Demo';
/**
 * The name of the LeanData BookIt object
 */
const leanDataObjectName = 'LDBookIt';

/**
 * Load and initialize LeanData BookIt script
 */
const loadBookIt = () => {
    window.LeanDataCalendaringObjName = leanDataObjectName;
    window.LDBookIt = (...args) => {
        window.LDBookIt.variables = args;
    };
    const scriptElement = document.createElement('script');
    scriptElement.async = 1;
    scriptElement.src = 'https://app.leandata.com/js-snippet/ld_calendaring.js';
    document.body.append(scriptElement);
    LDBookIt(orgId, nodeName, true, {apiRoutingOn: true});
}

const bookItAPIRouting = (formElement) => {
    let options = {
        /**
         * We are not using a plug-and-play form type we mark it as Custom.
         * (required)
         */
        MAType: 'Custom',
        /**
         * This is the HTML form element.
         * (required)
         */
        formHandle: formElement,
        /**
         * This scrapes the form data that will be passed to LeanData.
         * (required)
         */
        formDataCollector: (hiddenFieldNames) => {
            return jQuery(formElement)
                .serializeArray()
                .reduce((vals, field) => {
                    vals[field.name] = field.value;
                    return vals;
                }, {});
        },
        /**
         * Hook before submit and after running the routing
         * (optional)
         */
        afterRouting: (formData, responseData) => {
            window.localStorage.setItem(`LDCalendaring_custom_calendarLink`, responseData.calendarLink);
            window.localStorage.setItem(`LDCalendaring_custom_formInput`, JSON.stringify(responseData.formInput));
            window.localStorage.setItem(`LDCalendaring_custom_newTab`, responseData.newTab);
        },
        /**
         * As written this creates the log id field required to link prospect data and records created by
         * your marketing automation. If this field already exists on your form, this function is where
         * you will update the field with the log id value from the responseData.formInput variable.
         * The key in response.formInput that holds the log id is determined in the scheduling
         * node in the BookIt Flowbuilder graph.
         * (required)
         */
        hiddenFieldSetter: (options, formData, responseData, hiddenFieldNames) => {
            const logIdField = formElement.querySelector('input[name="LD_BookIt_Log_ID__c"]');
            logIdField.value = responseData.formInput.LD_BookIt_Log_ID__c || null;
        },
        /**
         * After the BookIt interception is done this function submits the form to its original target.
         * (optional)
         */
        formSubmitter: () => submitMarketoForm(formElement),
        /**
         * This runs after the form data is submitted to the form target (often an MA). In this case
         * we are triggering the LeanData redirect to the calendaring link if it exists.
         * (optional)
         */
        afterSubmit: (formData, responseData) => {
            // Redirect's to calendar link on leandata.com domain to display calendar
            // LDBookIt.redirect(options);
        },
    };
    // Submits the form data to LD for routing
    LDBookIt.submit(options);
};
